import { FAIcon } from "./faIcon.js";
import { Helper } from "../util/helper.js";
import { BaseField } from "./baseComponentProps.js";
import React from "react";
export class Region extends React.Component<RegionProps, {open?: boolean; isExtended?: boolean;}>{
    private _defined = Helper.hasValue;
    private _fieldsRef: HTMLElement = null;
    private _iconStyle: React.CSSProperties = {
        margin: "0 5px"
    };
    private _isBreak = false;

    constructor(props: RegionProps) {
        super(props);
        if (this._defined(props.breakStart)) {
            this._isBreak = true;
        }
        const open = Helper.hasValue(props.isInitiallyCollapsed) ? !props.isInitiallyCollapsed : true;
        this.state = { open: open};
    }

    private _setFieldsRef = (ref: HTMLElement) => {
        this._fieldsRef = ref;
    }

    private _toggleContent = (show: boolean) => {
        if (show) {
            $(this._fieldsRef).slideDown();
        } else {
            $(this._fieldsRef).slideUp();
        }
    }

    private _handleHeaderClick = () => {
        this.setState({ open: !this.state.open }, () => {
            !this.props.removeChildrenFromDomWhenCollapsed && this._toggleContent(this.state.open);
        });
    }

    render() {
        if (this._isBreak) {
            return <div className={"region region-break " /*+ this._getSizeClasses()*/} id={this.props.id} />
        } else {
            let fmcStyle: React.CSSProperties = {
                marginTop: this.props.renderHeader === false ? "0px" : null
            }

            const rfStyle: React.CSSProperties = {
                paddingTop: this.props.renderHeader === false ? "0px" : null
            };

            let header = this.props.renderHeader === false ? null :
                <div className="region__header" onClick={this._handleHeaderClick}>
                    <RegionHeaderIcon open={this.state.open} style={this._iconStyle} />
                    <span className="region__title">{this.props.title}</span>
                </div>;

            let flex = Helper.getValueOrDefault(this.props.flexContainer, false);

            let displayFlex = Helper.getValueOrDefault(this.props.displayFlex, false);

            if (displayFlex) {
                fmcStyle.display = "flex";
            }

            return (
                <div className={"region" + (this.state.open ? "" : " region--closed") + " " + (flex ? "flex-container" : "")} style={fmcStyle} id={this.props.id} >
                    {header}
                    <div className="region__fields" ref={this._setFieldsRef} style={rfStyle}>
                        {this.props.removeChildrenFromDomWhenCollapsed && !this.state.open ? null : this.props.children}
                    </div>
                </div>
            );
        }
    }
};

export const RegionHeaderIcon = ({ open, style }: { open: boolean, style?: React.CSSProperties }) => {
    return <> {Helper.useMobileGui() ?
        open ? <FAIcon name="chevron-circle-down" style={style} /> : <FAIcon name="chevron-circle-right" style={style} />
        :
        open ? <FAIcon name="minus" style={style} /> : <FAIcon name="plus" style={style} />
    }
    </>
}

interface RegionProps extends MetadataRegion {
    //title: string;
    //width?: number | string;
    //minWidth?: number | string;
    //maxWidth?: number | string;
    //renderHeader?: boolean;
    //id?: string;
}

export interface MetadataRegion extends React.PropsWithChildren {
    guid?: string;
    title: string;
    visible?: boolean | string | Function;
    fields?: Array<BaseField>;
    id?: string;
    width?: number | string;
    minWidth?: number | string;
    maxWidth?: number | string;
    renderHeader?: boolean;
    size?: RegionSizeRule | Array<RegionSizeRule>;
    breakStart?: RegionContainerSize;
    noSearchResult?: boolean;
    flexContainer?: boolean;
    displayFlex?: boolean;
    isInitiallyCollapsed?: boolean;
    removeChildrenFromDomWhenCollapsed?: boolean;
    enableGridLayout?: boolean;
    renderCollapsed?: boolean;
    extendedView?: boolean | string;
}

export interface RegionSizeRule {
    container: RegionContainerSize;
    width: "1/12" | "2/12" | "3/12" | "4/12" | "5/12" | "6/12" | "7/12" | "8/12" | "9/12" | "10/12" | "11/12" | "12/12";
    rowSize?: number;
}

export type RegionContainerSize = "extrasmall" | "small" | "medium" | "large" | "extralarge";